export default {
  common: {
    loading: 'Sedang dimuatkan',
    confirm: 'Sahkan',
    cancel: 'Batal',
    save: 'Simpan',
    back: 'Kembali',
    copy: 'Salin',
    delete: 'Padam',
    copySuccess: 'Disalin berjaya',
    editSuccess: 'Suntingan berjaya',
    deleteSuccess: 'Berjaya dipadam',
    modifySuccess: 'Berjaya dikemaskini',
    cannotBeEmpty: 'Tidak boleh kosong',
    noContent: 'Tiada kandungan',
    noData: 'Tiada data berkaitan',
    noMoreData: 'Tiada data tambahan',
    iKnow: 'Saya faham',
    selectService: 'Pilih penyedia perkhidmatan',
    sendSuccess: 'Berjaya dihantar',
  },
  billHome: {
    recharge: 'Perkhidmatan Tambah Nilai & Bayaran',
    coupon: 'Kupon',
    rechargeNow: 'Tambah Nilai Sekarang',
    cost: 'Kredit',
    flow: 'Data',
    rechargeNotice: 'Maklumat penting sebelum tambah nilai',
    rechargeCost: 'Tambah nilai kredit',
    rechargeFlow: 'Tambah nilai data',
    rechargeAmount: 'Jumlah tambah nilai',
    rechargePackage: 'Pakej tambah nilai',
    discount: 'Diskaun digunakan',
    confirmTxt: 'Sahkan betul',
    confirmTxt1: 'Saya faham',
    actualPayment: 'Jumlah Bayaran',
    selectCoupon: 'Pilih kupon',
    useRule: 'Peraturan penggunaan',
    availableCoupon: 'Kupon tersedia',
    unavailableCoupon: 'Kupon tidak tersedia',
    noAvailableCoupon: 'Tiada kupon tersedia',
    selectPhone: 'Pilih nombor telefon',
    pleaseInputPhone: 'Sila masukkan nombor telefon',
    couponCount: 'Kupon tersedia',
    pleaseInputCorrectPhone: 'Sila masukkan nombor telefon yang betul',
    pleaseSelectPackage: 'Sila pilih pakej tambah nilai',
  },
  accountManage: {
    title: 'Pengurusan Akaun',
    edit: 'Sunting',
    deleteConfirm: 'Sahkan untuk padam',
  },
  rechargeDetail: {
    title: 'Butiran Bayaran',
    continuePay: 'Teruskan Bayaran',
  },
  feesExpense: {
    title: 'Rekod Pembayaran',
    recharge: 'Nombor telefon',
    electricity: 'Bil elektrik',
    internet: 'Bil internet',
    water: 'Bil air',
    photo: 'Gambar',
    complete: 'Selesai',
    manage: 'Urus',
    allSelect: 'Pilih Semua',
    selected: 'Dipilih',
    deleteConfirm: 'Padam',
    deleteRecord: 'rekod bayaran ini?',
    noDataAction: 'Tiada data untuk diurus',
    pleaseSelect: 'Sila pilih rekod untuk dipadam',
    feesNotice: 'Maklumat penting sebelum bayar',
  },
  formCom: {
    upload: 'Klik untuk muat naik',
    saveAccount: 'Simpan atau kemaskini akaun',
    createOrder: 'Buat Pesanan',
    rechargeIng: 'Sedang tambah nilai',
    rechargeNow: 'Tambah Nilai Sekarang',
    serviceProvider: 'Penyedia Perkhidmatan',
    billImage: 'Gambar bil',
    returnSelect: 'Kembali untuk pilih semula',
    electricity: 'Bayaran Bil Elektrik',
    internet: 'Bayaran Bil Internet',
    water: 'Bayaran Bil Air',
    photo: 'Bayar guna gambar',
    life: 'Bayaran utiliti',
    uploadFail: 'Gagal muat naik, sila cuba semula',
    pleaseFill: 'Sila lengkapkan maklumat',
    submitSuccess: 'Dihantar berjaya, tunggu bayaran',
  },
  langPop: {
    selectLang: 'Pilih Bahasa',
  },
  loginPop: {
    loginOrRegister: 'Sila log masuk atau daftar akaun Kuaizi',
    confirmLogout: 'Adakah anda pasti ingin log keluar?',
    toLogin: 'Log Masuk',
    logoutSuccess: 'Log keluar berjaya',
  },
  newMe: {
    myOrder: 'Pesanan Saya',
    coupon: 'Kupon',
    accountManage: 'Pengurusan Akaun',
    orderCount: 'pesanan sedang diproses',
    couponCount: 'kupon',
    account: 'Akaun',
    logout: 'Log Keluar',
  },
  coupons: {
    all: 'Semua',
    coupon: 'Kupon',
    historyCoupon: 'Kupon yang lalu',
    use: 'Guna Sekarang',
    validityPeriod: 'Tempoh Sah',
    useRule: 'Peraturan Penggunaan',
    used: 'Telah Digunakan',
    expired: 'Tamat Tempoh',
  },
  accountSeting: {
    title: 'Tetapan',
    personalInfo: 'Maklumat Peribadi',
    modifyPayPassword: 'Tukar Kata Laluan Pembayaran',
    modifyLoginPassword: 'Tukar Kata Laluan Log Masuk',
    phone: 'Nombor Telefon',
    code: 'Kod Pengesahan',
    loginPassword: 'Kata Laluan Log Masuk',
    confirmModify: 'Sahkan Perubahan',
    noCode: 'Tidak terima kod?',
    passwordPlaceholder: '8–16 aksara gabungan huruf & nombor',
    inputCorrectPhone: 'Masukkan nombor telefon yang sah',
    afterGetCode: 'boleh dapatkan semula selepas itu',
    getCode: 'Dapatkan Kod',
    input6DigitPassword: 'Masukkan 6 digit kata laluan',
    twoInputPasswordNotConsistent: 'Kata laluan tidak sepadan',
    placeholderCode: 'Masukkan kod pengesahan',
    confirmPassword: 'Sahkan Kata Laluan',
    password: 'Kata Laluan',
    submit: 'Hantar',
    avatar: 'Gambar Profil',
    userName: 'Nama Pengguna',
    nickName: 'Nama Panggilan',
    modifyPhone: 'Tukar Nombor Telefon',
    nickNamePlaceholder: 'Tunjukkan identiti anda',
    sex: 'Jantina',
    male: 'Lelaki',
    female: 'Perempuan',
    email: 'Emel',
    emailPlaceholder: 'Masukkan emel untuk pemulihan kata laluan',
    pleaseCompletePersonalData: 'Lengkapkan maklumat diri untuk akses ciri tambahan',
    bindNewPhone: 'Pautkan Nombor Telefon Baharu',
    oldPhone: 'Nombor Lama',
    completeVerification: 'Sahkan Maklumat',
    changePayPasswordTitle: 'Tukar Kata Laluan Pembayaran',
    changePasswordTitle: 'Tukar Kata Laluan',
    oldPhoneTitle: 'Sahkan Nombor Lama',
    editInfoTitle: 'Edit Profil',
    areaCode: 'Kod kawasan',
  },
}
